import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-dark px-5 py-14" data-id="element-98" data-mp="3geze367ujv27">
      <div className="mx-auto max-w-5xl text-center" data-id="element-99" data-mp="3gh3n22klrk9c">
        <p className="font-display text-xl font-black uppercase tracking-tight text-white" data-id="element-100" data-mp="32p5m4f11ouo9">
          <span aria-hidden="true" data-id="element-101" data-mp="36qhdoq3hbpz3">♫ </span>Musique Prête™
        </p>
        <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-white/55" data-id="element-102" data-mp="3ufa7afwmplqj">
          La ressource définitive pour les profs de musique qui aiment leur
          métier.
        </p>
        <nav aria-label="Pied de page" data-id="element-103" data-mp="3lec7k9t840dr">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/65" data-id="element-104" data-mp="3ldkd52bd48p2">
            {footerLinks.map(link => <li key={link} data-id="element-105" data-mp="29yno3sf6hjhp">
                <a href="#offre" className="transition-colors hover:text-tangerine" data-id="element-106" data-mp="29ydwk0ehj49w">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-white/40" data-id="element-107" data-mp="3lbdaunotrzj6">
          © 2026 Musique Prête™ — Tous droits réservés.
        </p>
      </div>
    </footer>;
}